{
  "addressLoadFailed": "Không thể tải địa chỉ",
  "usdtTrc20": "USDT (TRC20)",
  "usdtTrc20Network": "USDT TRC-20",
  "rateLoadFailed": "Không thể tải tỷ giá",
  "copied": "Đã sao chép",
  "conversionDescription": "Sau khi nạp USDT, hệ thống sẽ quy đổi sang {{token}} theo tỷ giá USDT hiện tại của nền tảng và lưu trong ví {{token}} của bạn.",
  "rate": "Tỷ giá",
  "rateFromUsdt": "1 USDT ≈ {{amount}} {{token}}",
  "title": "Quy đổi",
  "hintTitle": "Lưu ý",
  "addressOnlySupports": "Địa chỉ và mã QR này chỉ hỗ trợ",
  "addressOnlySupportsSuffix": ". Chuyển sai loại có thể không khôi phục được và nền tảng không bồi hoàn. Vui lòng xác nhận loại token cần chuyển.",
  "confirmationHint": "Quy trình rút thông thường cần nhiều xác nhận blockchain. Hãy coi là hoàn tất khi tiền đã vào tài khoản."
}
